import React, { Component, ComponentType } from 'react'
import { Box, Button, Card, DialogActions, DialogContent, DialogTitle, styled } from '@mui/material'
import { fetchDelay } from '../utils'
import { IGlobalModalContext, mapGlobalModalContext } from '../api-context'

export interface IFormComfirmParam<T> {
  title?: string
  content: (value?: T) => JSX.Element
  colors?: {
    yes?: 'inherit' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning'
    no?: 'inherit' | 'error' | 'primary' | 'secondary' | 'success' | 'info' | 'warning'
  }
}

export interface IFormComfirmProps<T> {
  data?: T
  title?: string
  onSubmit: (value?: T) => Promise<void>
  onCancel?: () => void
}

export interface IFormComfirmState {
  loading?: boolean
}

const CreateFormComfirm = function <T = any>(param?: IFormComfirmParam<T>): ComponentType<React.PropsWithChildren<IFormComfirmProps<T>>> {
  class FormConfirm extends Component<React.PropsWithChildren<IFormComfirmProps<T>>, IFormComfirmState> {
    constructor(props: IFormComfirmProps<T>) {
      super(props)
      this.state = { loading: false }
    }

    render() {
      const content = this.props.children || (param?.content ? param?.content(this.props.data) : undefined)
      const title = this.props.title ?? param?.title ?? 'Are you sure?'
      return (
        <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          {mapGlobalModalContext((context) => (
            <Card>
              <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
              <DialogContent sx={{ minWidth: '300px' }}>{content}</DialogContent>
              <DialogActions>
                <CustomButton disabled={this.state.loading} color={param?.colors?.no || 'inherit'} onClick={() => this.handleClickNo(context)}>
                  No
                </CustomButton>
                <CustomButton color={param?.colors?.yes || 'error'} disabled={this.state.loading} onClick={() => this.handleClickYes(context)}>
                  Yes
                </CustomButton>
              </DialogActions>
            </Card>
          ))}
        </Box>
      )
    }

    handleClickNo = (context: IGlobalModalContext) => {
      context.close()
      this.props.onCancel && this.props.onCancel()
    }

    handleClickYes = async (context: IGlobalModalContext) => {
      if (!this.props.onSubmit) return
      try {
        this.setState({ loading: true })
        await fetchDelay(() => this.props.onSubmit(this.props.data), 700)
        context.close()
      } catch (error) {
        console.log('Handle Click Yes error:', error)
      } finally {
        this.setState({ loading: false })
      }
    }
  }
  return FormConfirm
}
export default CreateFormComfirm

const CustomButton = styled(Button)({
  textTransform: 'capitalize',
  fontWeight: 600,
  '&.MuiButton-colorInherit': {
    color: '#606060!important'
  }
})
